import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./Assests/Scss/PerformanceEachStudent.scss";
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import Loading from "../Student/Reusablecomponents/Loading";
// import Table from "../Student/Reusablecomponents/Table";
import { FaAnglesLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import {
  AssessmentName,
  // Grade,
  SUbjects,
  Section,
} from "../Student/Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import { ExportXlButton } from "../ReusableComponents/CommonComponents";
import { DownloadExcel } from "../ReusableComponents/CommonFunctions";
// import ReuseTable from "../ReusableComponents/Table";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../ReusableComponents/CommonApis";
const PerformanceEachStudent = () => {
  const navigate = useNavigate();
  const [EachStudentData, SetEachStudentData] = useState([]);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const Filters = JSON.parse(localStorage.getItem("DiFFInput"));
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const [GetGrade, SetGetGrade] = useState(Filters?.Grade);
  const [GetSection, SetGetSection] = useState(Filters?.Section);
  const [GetSubject, SetGetSubject] = useState(Filters.Subject);
  const [Marks, SetMarks] = useState();
  const [Load, SetLoad] = useState(false);
  // const columns = [
  //   { key: "id", header: "Sl.No" },
  //   { key: "studentName", header: "Name" },
  //   { key: "marks", header: "Score" },
  //   { key: "marksPercentage", header: "Score %" },
  // ];

  const GetEachStudentMarks = async () => {
    // SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/TeachersDashboard/GetStudentwiseMarksBySubject?ContestCreationId=${SelectDate?.value}&SubjectName=${GetSubject}&SchoolId=${items.schoolId}&Grade=${GetGrade}&Section=${GetSection}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].studentName) {
          SetEachStudentData(res.data);
        } else {
          SetEachStudentData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        // SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  // const halfLength = Math.ceil(EachStudentData?.length / 2);
  // const firstHalf = EachStudentData?.slice(0, halfLength);
  // const secondHalf = EachStudentData?.slice(halfLength);

  const NavigatetoDifflevel = () => {
    const data = {
      Subject: GetSubject,
      Section: GetSection,
      Grade: GetGrade,
      SubjectsList: Filters?.SubjectsList,
      SectionsList: Filters?.SectionsList,
    };
    navigate("/TeacherDashboard/TeacherDifficultyLevel", { replace: true });
    localStorage.setItem("DiFFInput", JSON.stringify(data));
  };

  const GetSubjects = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/TeachersDashboard/GetSubjectsByGrade?ContestCreationId=${SelectDate?.value}&SchoolId=${items.schoolId}&Grade=${GetGrade}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          const StoreSubjects = res.data.map((subject) => subject.subjectName);
          SetGetSubject(
            Filters?.Subject ||
              (StoreSubjects.includes(GetSubject) && GetSubject) ||
              StoreSubjects[0]
          );
          SetMarks(
            res.data.filter(
              (subject) =>
                subject.subjectName === Filters?.Subject ||
                (StoreSubjects.includes(GetSubject) && GetSubject) ||
                StoreSubjects[0]
            )[0]?.maxScore
          );
          GetEachStudentMarks();
          const data = {
            Section: GetSection,
            Grade: GetGrade,
            SubjectsList: Filters?.SubjectsList,
            SectionsList: Filters?.SectionsList,
          };
          localStorage.setItem("DiFFInput", JSON.stringify(data));
        } else {
          SetEachStudentData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
     if(SelectDate?.value){
    GetSubjects();}
  }, [GetGrade, SelectDate?.value, GetSection, GetSubject]);
  const DownloadXl = () => {
    const XL = EachStudentData?.map((item, index) => {
      return {
        SNo: index + 1,
        Name: item.studentName,
        Score: item.marks,
        "Score %": `${item.marksPercentage}%`,
      };
    });
    DownloadExcel(
      XL,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      false,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      true
    );
  };
  const columns = [
    { name: "Student Id", selector: "studentId" },
    { name: "Name", selector: "studentName" },
    { name: "Score", selector: "marks" },
    {
      name: "Score %",
      selector: "marksPercentage",
      cell: (row) => <div> {row.marksPercentage}%</div>,
    },
  ];
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(items?.instituteId, SelectDate, USYear?.value,items?.userId);
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(
      Grades?.map((grade) => ({
        display: `Grade ${grade}`,
        value: grade.trim(),
      }))
    );
    SetGetGrade(Filters?.Grade || Grades?.[0]);
  };
  useMemo(() => {
    if (SelectDate) {
      GetAssmentdates();
    }
  }, [SelectDate]);
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <button className="Buttons mt-2" onClick={NavigatetoDifflevel}>
          <FaAnglesLeft /> Performance by difficulty level{" "}
        </button>
        <div className="MainHeading">
          Student wise performance -{" "}
          {AssessmentName(SelectDate?.assessmentType)} -{" "}
          {SelectDate?.examStartDate}
        </div>
        <div className=" dflex JSBetween alignitems mt-2">
          <div></div>
          <div className=" dflex alignitems" style={{ gap: "10px" }}>
            {SelectDate?.value > 0 && (
              <>
                {/* <Grade
                    className="NCLDropdown"
                    PostGrade={SetGetGrade}
                    selected={"Grade " + GetGrade}
                  /> */}
                <DropdownValues
                  className="NCLDropdown"
                  options={ASSGrade}
                  selectoption={GetGrade}
                  Displayname="Select Grade"
                  onChange={(e) => SetGetGrade(e.target.value)}
                />
                {GetGrade > 0 && (
                  <>
                    <Section
                      className="NCLDropdown"
                      Postsection={SetGetSection}
                      selected={"Section " + GetSection}
                      Options={Filters?.SectionsList}
                    />
                    {GetSection !== -1 && (
                      <SUbjects
                        className="NCLDropdown"
                        Postsubject={SetGetSubject}
                        selected={GetSubject}
                        Options={Filters?.SubjectsList}
                      />
                    )}{" "}
                  </>
                )}{" "}
              </>
            )}

            <div style={{ fontSize: "15px", fontWeight: "bold" }}>
              {" "}
              Max Score : {Marks}
            </div>
            {EachStudentData?.[0]?.studentName && (
              <ExportXlButton
                Name="Export to Excel"
                Click={() => DownloadXl()}
              />
            )}
          </div>
        </div>
        {/* {EachStudentData?.[0]?.studentName ? (
            <> */}
        {/* <div
                className=" NCLDataTable " */}
        {/* // PEStudent
                // style={ */}
        {/* //   EachStudentData.length > 10
                //     ? {}
                //     : { padding: "0vw 20vw", gridTemplateColumns: "none" }
                // }
              // > */}
        {/* {firstHalf?.[0]?.studentName && ( */}
        <DataTable
          ShowPagination={true}
          Dropdownvalues={[10, 25, 50, 100]}
          className="NCLDataTable Card mt-2"
          ShowPagecount={true}
          columns={columns}
          data={EachStudentData}
          // data={EachStudentData.length > 10 ? firstHalf : EachStudentData}
        />
        {/* )} */}

        {/* {EachStudentData.length > 10 && (
                <ReuseTable className="NCLDataTable"
                  columns={columns}
                  data={secondHalf}
                  SNO={firstHalf.length}
                />
              )} */}
        {/* // </div> */}
        {/* </>
          // ) : (
          //   <div className="ErrorMessage">{EachStudentData}</div>
          // )} */}
        {/* <CopyRight /> */}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default PerformanceEachStudent;
